import { FeatureFlag } from '../utils/launchDarklyUtils';

// TODO: Currently product tier is used and changing it would cause errors. Remove product tier and propogate changes
export enum PaidSubscriptionStatus {
  VALID = 'valid',
  CANCELLED = 'cancelled',
}

export enum Package {
  STARTER = 'starter',
  ADVANCED_ANALYTICS = 'coreAdvancedAnalytics',
  LABOR_PAYROLL = 'coreLaborPayroll',
  INVENTORY = 'coreInventory',
  SCHEDULING = 'coreScheduling',
}

export const PackageToFeatureFlagMapping: Record<Package, FeatureFlag> = {
  [Package.STARTER]: FeatureFlag.starterPackage,
  [Package.ADVANCED_ANALYTICS]: FeatureFlag.corePackageAdvancedAnalytics,
  [Package.LABOR_PAYROLL]: FeatureFlag.corePackageLaborAndPayroll,
  [Package.INVENTORY]: FeatureFlag.corePackageInventory,
  [Package.SCHEDULING]: FeatureFlag.corePackageScheduling,
};
